export const getInsurances = (clientId: string = "conte") => {
  const insurancesByClient = INSURANCES[clientId];
  if (!insurancesByClient) return INSURANCES["conte"];
  return insurancesByClient;
};

const INSURANCES = {
  conte: [
    "ADMIRAL EUROPE COMPANIA DE SEGUROS SA-911",
    "ABC ASSICURA S.p.A.-273",
    "ADRIATIC OSIGURANJE D.D.-667",
    "AIG EUROPE SA-344",
    "AIOI NISSAY DOWA INS. CO. OF EUROPE SE-872",
    "ALLIANZ DIRECT SOCIETA' PER AZIONI-139",
    "ALLIANZ S.p.A. - 3",
    "ALTRA COMPAGNIA-900",
    "AMTRUST INTERNATIONAL UNDERWRITERS DAC-610",
    "ARCA ASSICURAZIONI S.p.A.-417",
    "ASSICURATRICE MILANESE S.p.A.-327",
    "ASSICURATRICE VAL PIAVE S.p.A.-85",
    "ASSICURAZIONI GENERALI S.p.A.-483",
    "ASSIMOCO S.p.A.-254",
    "AVIVA ITALIA S.p.A.-352",
    "AXA ASSICURAZIONI S.p.A.-14",
    "AXA MPS ASSICURAZIONI DANNI S.p.A.-243",
    "BCC ASSICURAZIONI S.p.A.-418",
    "BENE ASSICURAZIONI S.p.A.-486",
    "BIPIEMME ASSICURAZIONI S.p.A.-482",
    "CARGEAS ASSICURAZIONI-304",
    "CHUBB EUROPEAN GROUP SE-853",
    "COMPAGNIA ASSICURATRICE LINEAR-416",
    "CREDEMASSICURAZIONI-428",
    "CRÉDIT AGRICOLE ASSICURAZIONI-472",
    "DARAG ITALIA S.p.A.-293",
    "EURO INSURANCES DAC-909",
    "EUROHERC OSIGURANJE D.D.-971",
    "GENERALI ITALIA-5",
    "GENERTEL-247",
    "GREAT LAKES INSURANCE SE-899",
    "GREENVAL INSURANCE DAC-964",
    "GROUPAMA ASSICURAZIONI-151",
    "HDI ASSICURAZIONI-133",
    "HDI ITALIA S.P.A.-86",
    "HELVETIA ITALIA ASSICURAZIONI S.p.A.-292",
    "HELVETIA-19",
    "HDI GLOBAL SE-218",
    "INCONTRA ASSICURAZIONI-281",
    "INSURANCE JSC DALLBOGG: LIFE AND HEALTH-920",
    "INTESA SANPAOLO ASSICURA S.p.A.-419",
    "IPTIQ EMEA PC SA-671",
    "IPTIQ EMEA P&C SA DE-970",
    "ITALIANA ASSICURAZIONI-23",
    "ITAS-ISTITUTO TRENTINO ALTO ADIGE PER ASSICURAZIONI-22",
    "LE ASSICURAZIONI DI ROMA-212",
    "NOBIS COMPAGNIA DI ASSICURAZIONI-474",
    "NON ASSICURATO-0",
    "QUIXA ASSICURAZIONI S.p.A.-440",
    "SARA ASSICURAZIONI-32",
    "SIAT-175",
    "SOCIETÀ CATTOLICA DI ASSICURAZIONE-57",
    "SOCIETÀ REALE MUTUA DI ASSICURAZIONI-35",
    "SOGESSUR S.A.-600",
    "TUA ASSICURAZIONI-429",
    "UNICREDIT ALLIANZ ASSICURAZIONI-346",
    "UNIPOL ASSICURAZIONI S.P.A. -34",
    "PIU'VERA ASSICURAZIONI S.P.A.",
    "VERTI ASSICURAZIONI S.p.A.-432",
    "VITTORIA ASSICURAZIONI S.p.A.-38",
    "WAKAM-955",
    "WEFOX INSURANCE AG-922",
    "ZURICH INSURANCE COMPANY LIMITED-198",
    "ZURICH INSURANCE PLC-864",
    "ZAVAROVALNICA TRIGLAV D.D.-924",
    "VIA VERSICHERUNG AG.",
  ],
} as Record<string, Array<string>>;
